export const ConfigurationsKeys = {
  TERMS: 'TERMS',
  BANK_SLIP_BANK_CODE: 'BANK_SLIP_BANK_CODE',
  BANK_SLIP_INSTRUCTIONS: 'BANK_SLIP_INSTRUCTIONS',
  BANK_SLIP_DUE_DAYS: 'BANK_SLIP_DUE_DAYS',
  BANK_SLIP_NOSSO_NUMERO: 'BANK_SLIP_NOSSO_NUMERO',
  BANK_SLIP_TYPE: 'BANK_SLIP_TYPE',
  BANK_SLIP_STATEMENT_DESCRIPTOR: 'BANK_SLIP_STATEMENT_DESCRIPTOR'
}
